export enum AddonSaleBundleStrategy {
    Nbo = 'nbo',
    Bundle = 'bundle',
}
